import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		container: {
			width: "100%",
			height: "100%",
			position: "relative",
			overflow: "hidden",
			borderRadius: 8,
		},
	} satisfies Record<string, CSSObject>);
};
